export type CalendarTab = "events" | "reservations";
export const EVENTS_TAB: CalendarTab = "events";
export const RESERVATIONS_TAB: CalendarTab = "reservations";

export interface CalendarData<T> {
  items: T[];
  total: number;
  isLoading: boolean;
  hasMore: boolean;
  loadMore: () => Promise<unknown>;
  isLoadingMore: boolean;
}
